import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import axios from "axios";
import { KATALOG_API } from "../../consts/Endpoints";
import { PATH_T_CARD_DETAIL, PATH_H_CARD_DETAIL, PATH_A_CARD_DETAIL, PATH_N_CARD_DETAIL, PATH_PZ_CARD_DETAIL, PATH_IX_CARD_DETAIL, PATH_E_CARD_DETAIL } from "../../consts/RouterPaths";
import { tl } from "../FiyatGecmisi";
import "./digerMagazalar.css";
import trendyolLogo from "../../images/pazaryeri/trendyol-logo.svg";
import hepsiburadaLogo from "../../images/pazaryeri/hepsiburada-logo.svg";
import amazonLogo from "../../images/pazaryeri/amazon-logo.svg";
import n11Logo from "../../images/pazaryeri/n11-logo.svg";
import mediamarktLogo from "../../images/pazaryeri/mediamarkt-logo.svg";
import vatanLogo from "../../images/pazaryeri/vatan-logo.svg";
import pazaramaLogo from "../../images/pazaryeri/pazarama-logo.png";
import idefixLogo from "../../images/pazaryeri/idefix-logo.svg";

// Katalog mağaza kodları (teklif.magaza) → görünen ad / renk. Amazon fiyatı sitede gösterilmez (ortaklık koşulu).
const MAGAZA = {
  TRENDYOL: { ad: "Trendyol", renk: "#f27a1a", logo: trendyolLogo },
  HEPSIBURADA: { ad: "Hepsiburada", renk: "#ff6000", logo: hepsiburadaLogo },
  AMAZON: { ad: "Amazon", renk: "#111827", fiyatGizle: true, logo: amazonLogo },
  N11: { ad: "n11", renk: "#5b2c83", logo: n11Logo },
  MEDIAMARKT: { ad: "MediaMarkt", renk: "#df0000", logo: mediamarktLogo },
  VATAN: { ad: "Vatan Bilgisayar", renk: "#1d4ed8", logo: vatanLogo },
  PAZARAMA: { ad: "Pazarama", renk: "#2541e6", logo: pazaramaLogo },
  IDEFIX: { ad: "İdefix", renk: "#006bdc", logo: idefixLogo },
};
// indirim aynasının kaynağı (mağaza veritabanı) → bizim indirim detay sayfası
const DETAY = { TRENDYOL: PATH_T_CARD_DETAIL, HEPSIBURADA: PATH_H_CARD_DETAIL, AMAZON: PATH_A_CARD_DETAIL, N11: PATH_N_CARD_DETAIL, ELEKTRONIK: PATH_E_CARD_DETAIL, PAZARAMA: PATH_PZ_CARD_DETAIL, IDEFIX: PATH_IX_CARD_DETAIL };
// site (SITELER anahtarı) → katalog mağaza kodu; elektronikte ürünün kendi mağazası
const SITE_KODU = { trendyol: "TRENDYOL", hepsiburada: "HEPSIBURADA", amazon: "AMAZON", n11: "N11", pazarama: "PAZARAMA", idefix: "IDEFIX" };

/**
 * "Diğer mağazalarda": katalog servisinin eşleştirdiği aynı ürün (marka + model + renk + kapasite) başka mağazalarda kaç
 * para, mağaza başına en ucuz teklif. Veri tarayıcıdan katalog servisine (detay verisinden bağımsız; gelmezse kutu görünmez).
 * Props: site, u (ürün / indirim kaydı: id, magaza), fiyat (bu sayfadaki fiyat, kıyas için; Amazon'da verilmez).
 */
export default function DigerMagazalar({ site, u, fiyat }) {
  const [liste, setListe] = useState(null);
  const magaza = site === "elektronik" ? u && u.magaza : SITE_KODU[site];
  const urunId = u && u.id != null ? String(u.id) : null;

  useEffect(() => {
    if (!KATALOG_API || !magaza || !urunId) return;
    let iptal = false;
    axios.get(KATALOG_API + "api/digerleri", { params: { magaza, urunId } })
      .then((r) => { if (!iptal) setListe(Array.isArray(r.data) ? r.data : []); })
      .catch(() => { if (!iptal) setListe([]); });
    return () => { iptal = true; };
  }, [magaza, urunId]);

  if (!liste || liste.length === 0) return null;
  const enUcuz = Math.min(...liste.filter((x) => !(MAGAZA[x.magaza] || {}).fiyatGizle).map((x) => x.fiyat));
  return (
    <section className="dm" aria-label="Diğer mağazalarda">
      <div className="dm-ust">
        <h3 className="dm-baslik">Aynı ürün diğer mağazalarda</h3>
        <span className="dm-sayi">{liste.length} mağaza</span>
      </div>
      <ul className="dm-liste">
        {liste.map((x) => {
          const m = MAGAZA[x.magaza] || { ad: x.magaza, renk: "#374151" };
          const fark = !m.fiyatGizle && fiyat ? Math.round(fiyat - x.fiyat) : null;
          // oran yoksa (eski kayıt) rozet gösterilmez: "% indirimde" yazıyordu
          const oran = x.indirim && Number(x.indirim.oran) > 0 ? Number(x.indirim.oran) : null;
          const enIyi = !m.fiyatGizle && x.fiyat === enUcuz && fiyat && x.fiyat < fiyat * 0.99;
          return (
            <li key={x.magaza} className={"dm-satir" + (enIyi ? " dm-en-ucuz" : "")}>
              <span className="dm-magaza">
                {m.logo ? <img src={m.logo} alt={m.ad} loading="lazy" /> : <b style={{ color: m.renk }}>{m.ad}</b>}
              </span>
              <span className="dm-orta">
                <span className="dm-fiyat">{m.fiyatGizle ? "Fiyat Amazon'da" : tl(x.fiyat)}</span>
                {fark != null && Math.abs(fark) >= Math.max(1, fiyat * 0.01) ? (
                  <span className={"dm-fark " + (fark > 0 ? "dm-fark-ucuz" : "dm-fark-pahali")}>
                    {fark > 0 ? `${tl(fark)} daha ucuz` : `${tl(-fark)} daha pahalı`}
                  </span>
                ) : fark != null ? <span className="dm-fark">aynı fiyat</span> : null}
                {oran && DETAY[x.indirim.kaynak] ? (
                  <Link className="dm-indirim" to={DETAY[x.indirim.kaynak] + "?oid=" + x.indirim.oid}>%{oran} indirimde</Link>
                ) : x.yol ? (
                  <Link className="dm-gecmis" to={x.yol}>Fiyat geçmişi</Link>
                ) : null}
              </span>
              <a className="dm-git" href={x.url} target="_blank" rel="noopener noreferrer sponsored"
                style={{ color: m.renk, borderColor: m.renk + "55" }} aria-label={m.ad + " sayfasına git"}>Git →</a>
            </li>
          );
        })}
      </ul>
      <p className="dm-not">Aynı ürünü (marka, model, renk ve kapasite) mağazalarda eşleştiriyoruz; fiyatlar son taramamıza göre.</p>
    </section>
  );
}
